<script setup lang="ts">
import { computed } from "vue"
import { useRoute } from 'vue-router'
import DropdownCurrency from '~/components/globals/Header/elements/DropdownCurrency/DropdownCurrency.vue'
import SectionLocalDesigner from '~/components/pages/TripPlanDetail/sections/SectionLocalDesigner/SectionLocalDesigner.vue'
import TripButton from '~/components/pages/TripPlanDetail/sections/SectionTripPriceBox/TripButton.vue'
import DJIcon from '~/components/ui/icon/Icon.vue'
import { IconCheck, IconHandWithdrawFill } from '~/components/ui/icon/icons'
import { isEmpty, publicDomain } from '~/helper'
import { useTripPlanStore } from '~/store/pinia/tripPlan'

const emit = defineEmits(['customTrip', 'scrollToInclusions'])

const route = useRoute()
const domain = publicDomain()
const tripPlanStore = useTripPlanStore()

const dataTrip = computed(() => tripPlanStore.dataTrip)
const designer = computed(() => {
  if (isEmpty(dataTrip.value)) return null
  return dataTrip.value.designer || null
})
const benefits = computed(() => {
  if (isEmpty(dataTrip.value)) return null
  return dataTrip.value.trip_benefits || null
})
const currencyDisplay = computed(() => tripPlanStore.priceDisplayAPI?.currency_symbol)
const priceDisplayGallery = computed(() => tripPlanStore.priceDisplayAPI)
const tripButtonClass = computed(() => {
  if ((domain === 'agent' && dataTrip.value?.type === 'bookable') || domain === 'traveller') return 'button button-yellow-medium wp-100'
  else return 'button button-blue'
})
const idTrackingEnquiryButtonTop = computed(() => {
  if (route.name === 'trip-plan') return 'gallery-trip-plan-button-enquire-top'
  return ''
})
</script>

<template>
  <div id="trip-plan-box" class="wp-100 bd-1 flex flex-column br-8 bd-gray-300-brand sd-1 bg-white" v-bind="$attrs">
    <div class="pa-16 pb-12">
      <div class="flex items-center justify-between">
        <span class="text-md-rg gray-700">Starting From</span>
        <DropdownCurrency
          :showCodeCurrent="true"
          classButton="px-8 bd-1 bd-brand-950 br-1000 ml-8"
          classButtonText="fw-700 fs-18 lh-28 mr-4 gray-900 mb-fs-18 mb-lh-28"
        />
      </div>
      <div class="flex flex-wrap items-end">
        <span class="heading-3 mr-8 mt-4">{{ `${currencyDisplay} ${priceDisplayGallery.perPerson}` }}</span>
        <span class="text-md-rg gray-700 mb-4">/ per traveller sharing</span>
      </div>
      <div class="flex items-center">
        <DJIcon :size="20" color="#3E9377" class="mr-4">
          <IconHandWithdrawFill />
        </DJIcon>
        <span class="text-md-rg">Get a fully customised trip plan today</span>
      </div>
    </div>
    <div class="px-16 py-8 flex flex-column grid-gap-8 bg-gray-50">
      <span class="text-md-rg gray-700 mb-text-sm-rg">Benefits of this trip</span>
      <div class="flex" v-for="(benefit, index) in benefits" :key="index">
        <DJIcon :size="20" color="#3E9377" class="mr-4">
          <IconCheck />
        </DJIcon>
        <span class="gray-950 mb-text-sm-rg text-md-rg">{{ benefit }}</span>
      </div>
      <div class="flex hand w-fit-content" @click.prevent="$emit('scrollToInclusions')">
        <DJIcon :size="20" color="#3E9377" class="mr-4">
          <IconCheck />
        </DJIcon>
        <span class="text-md-rg mb-text-sm-rg gray-950 underline">More Inclusions</span>
      </div>
      <div class="bd-b-d-1 bd-gray-300-brand"></div>
      <span class="text-md-rg mb-text-sm-rg gray-700">Designed by</span>
      <SectionLocalDesigner v-if="designer" :designer-id="designer?.id" :designer-info="designer" />
    </div>
    <div class="wp-100 tl-w-auto mb-wp-100 px-16 py-8">
      <TripButton :customClass="tripButtonClass" :show-suffix-icon="true" :buttonID="idTrackingEnquiryButtonTop" @customTrip="$emit('customTrip')" />
      <div class="text-sm-md gray-700 wp-100 tc mt-6">All the activities you love, and nothing you don't</div>
    </div>
  </div>
</template>

<style lang="scss" scoped></style>
